import { Controller } from "@hotwired/stimulus"
import { getFontEmbedCSS, toBlob } from "html-to-image"

const WIDTH = 1200
const HEIGHT = 630

export default class extends Controller {
  static targets = ["preview", "card"]

  connect() {
    this.observer = new ResizeObserver(() => this.resize())
    this.observer.observe(this.previewTarget)
  }

  disconnect() {
    this.observer.disconnect()
  }

  resize() {
    this.previewTarget.style.setProperty("--tweet-card-scale", this.previewTarget.clientWidth / WIDTH)
  }

  copy({ currentTarget, params: { text } }) {
    this.write(navigator.clipboard.writeText(text), currentTarget, "Text copied")
  }

  copyImage({ currentTarget }) {
    const image = new ClipboardItem({ "image/png": this.render() })

    this.write(navigator.clipboard.write([image]), currentTarget, "Image copied")
  }

  async publish({ currentTarget, params: { url } }) {
    currentTarget.disabled = true
    const tab = window.open("", "_blank")

    try {
      const body = new FormData()
      body.append("image", await this.render(), "card.png")

      const response = await fetch(url, {
        method: "POST",
        body,
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
          Accept: "application/json"
        }
      })
      if (!response.ok) throw new Error(response.statusText)

      const { intent, next } = await response.json()
      tab.location = intent
      window.location = next
    } catch {
      tab.close()
      currentTarget.disabled = false
      this.toast("Failed to publish", "error")
    }
  }

  async render() {
    this.fonts ||= getFontEmbedCSS(this.cardTarget)

    return toBlob(this.cardTarget, {
      width: WIDTH,
      height: HEIGHT,
      fontEmbedCSS: await this.fonts,
      style: { transform: "none" }
    })
  }

  write(promise, target, message) {
    promise
      .then(() => {
        target.classList.add("tweet-idea--copied")
        setTimeout(() => target.classList.remove("tweet-idea--copied"), 1500)
        this.toast(message, "success")
      })
      .catch(() => this.toast("Failed to copy to clipboard", "error"))
  }

  toast(message, type) {
    window.dispatchEvent(new CustomEvent("toast:show", { detail: { message, type } }))
  }
}
